import React, { useCallback, useRef, useState } from "react";
import BorderHeading from "../../components/heading/BorderHeading";
import "./FileUpload.css";
import { uploadDocument } from "../../services/bankingService";
import cameraIcon from "../../images/upload_themeColor6.png";
import { Button, CircularProgress, TextField } from "@mui/material";
import pdfIcon from "../../images/PDF.png";
import pptIcon from "../../images/PPT.png";
import excelIcon from "../../images/XLS.png";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";

const FileUpload = () => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT = "Blobkey"
  const CUR_COMPONENT_COMMON="commonPortal";
  const ACCEPTED_FILE_TYPES = "image/png, image/jpeg, image/gif, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/pdf, text/csv, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.ms-powerpoint, application/JSON";
  const authContext = localStorage.getItem("authContext") && JSON.parse(localStorage.getItem("authContext") as string);
  
  const [blobKey, setBlobKey] = useState<string>("");
  const [fileUploaded, setFileUploaded] = useState<Blob>();
  const [selectedFile, setSelectedFile] = useState<string>("");
  const [imageIcon, setImageIcon] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);

  const fileInputRef = useRef() as React.MutableRefObject<HTMLInputElement>;

  const generateBlob = useCallback(async () => {
    if (!fileUploaded) {
      if(isLoading) setIsLoading(false);
      openPopup('Alert', "Please upload a file");
      return;
    }
    const formData = new FormData();
    setIsLoading(true);
    formData.append("files", fileUploaded, selectedFile);
    const fileUploadResponse = await uploadDocument(formData);
    const blobKey: string = JSON.parse(fileUploadResponse[0].body).features[0]
      .Uri;
    setBlobKey(blobKey);
    setIsLoading(false);
  }, [fileUploaded, selectedFile, authContext]);

  const handleClearAll = useCallback(() => {
    if(isLoading) setIsLoading(false);
    setBlobKey("");
    setSelectedFile("");
    setFileUploaded(undefined);
    fileInputRef.current.value = "";
  }, []);

  const handleClick = useCallback(() => {
    if(isLoading) setIsLoading(false);
    fileInputRef.current && fileInputRef.current.click();
  }, []);

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if(isLoading) setIsLoading(false);
    const fileUploaded = event.target.files?.[0];
    if (fileUploaded) {
      setFileUploaded(fileUploaded);
      setSelectedFile(fileUploaded.name);
      if (fileUploaded.type === "application/pdf") {
        setImageIcon(pdfIcon);
      } else if (
        fileUploaded.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        fileUploaded.type === "text/csv" ||
        fileUploaded.type === "application/vnd.ms-excel"
      ) {
        setImageIcon(excelIcon);
      } else if (
        fileUploaded.type ===
          "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
        fileUploaded.type === "application/vnd.ms-powerpoint"
      ) {
        setImageIcon(pptIcon);
      }else if (
        fileUploaded.type === "application/json"
      ) {
        setImageIcon(pdfIcon);
      } else {
        setImageIcon(URL.createObjectURL(fileUploaded));
      }
    }
  };

  return (
    <div className="file_upload_container">
      <BorderHeading>{translate(TranslationEnum.blobkey,"BLOBKEY GENERATOR")}</BorderHeading>
      <div className="file_upload_div" onClick={handleClick}>
        <input
          ref={fileInputRef}
          type="file"
          style={{ display: "none" }}
          onChange={handleFileUpload}
          accept={ACCEPTED_FILE_TYPES}
        />
        {fileUploaded ? (
          <div className="image">
            <img
              width={60}
              height={65}
              src={imageIcon}
              alt= {translate(TranslationEnum.common_portal,"Image not available")}
            />
            {selectedFile}
          </div>
        ) : (
          <div className="icon_and_text">
            <img width={50} height={45} src={cameraIcon}></img>
            {translate(TranslationEnum.common_portal,"Upload photo image, pdf, excel or json")}
          </div>
        )}
      </div>
      <div className="display_blob_key">
        <TextField
          id="outlined-basic"
          label={translate(TranslationEnum.blobkey,"Blob Key")}
          variant="outlined"
          InputProps={{
            readOnly: true,
          }}
          value={blobKey}
        />
      </div>
      <div className="buttons">
        <Button
          variant="contained"
          sx={{ backgroundColor: "#23c6b0" }}
          onClick={generateBlob}
        >
          {isLoading ? <CircularProgress size={24} /> : <>{translate(TranslationEnum.blobkey,"Generate Link")}</>}
        </Button>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#23c6b0" }}
          onClick={handleClearAll}
        >
          {translate(TranslationEnum.blobkey,"Clear All")}
        </Button>
      </div>
    </div>
  );
};
export default FileUpload;
